import { IServiceStatusState } from './state';
import { IServiceStatusAction } from './action';

export const defaultState: IServiceStatusState = {
    idx: 0,
    serviceType: '',
    status: '',
    isProfile: false,
    isOffer: false,
    isMember: false,
    createdDate: '',
    serviceStatusHistoryList: [],
    hasProfileImage: false,
};

export interface IServiceStatusReducer {
    (state: IServiceStatusState, action: IServiceStatusAction): IServiceStatusState;
}

export default function serviceStatusReducer(state: IServiceStatusState, action: IServiceStatusAction): IServiceStatusState {
    const { type, value } = action;

    switch (type) {
        case 'SET_STATE':
            state = { ...value };
            break;
        default: state = defaultState
            break;
    }

    return state;
}
